import React, { useEffect, useState } from 'react';
import './ProjectView.css';

import * as Loader from 'react-spinners';
import { useNavigate } from 'react-router-dom';

import { getFrameDim } from '../../Utility/Utility';
import * as Network from '../../Network/Network';
import PageTitle from '../../Common/PageTitle/PageTitle'; // Adjust the path as per your file structure
import MapItButton from '../../Common/MapItButton/MapItButton';

import {BrowserView, MobileView, isMobileOnly, isMobile, isAndroid, isIOS} from 'react-device-detect'

const prod_host = "https://server.mapit.cc";

const ProjectView = ({user, setUser}) => {

  const [curProj, setCurProj] = useState(user && user.projects && Object.keys(user.projects).length != 0?Object.keys(user.projects).reverse()[0]:-1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [ssDoubleClicked, setSSDoubleClicked] = useState(0);
  const [snapSize, setSnapSize] = useState(0.025);
  const [projTrxMap, setProjTrxMap] = useState({});
  const [loading, setLoading] = useState(true);

  const reverseProjectKeys = Object.keys(user.projects).reverse();

  let navigate = useNavigate();

  useEffect(() => {
    // if (user && user.projects && Object.keys(user.projects).length != 0) {
    //   console.log(`print remote path`);
    //   console.log(`https://d1se9yqadop5at.cloudfront.net/${user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].remote_file_path}`);
    //   console.log(`new project`);
    //   console.log(user.projects);
    // }

    updateUserObj();
 
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      // let width = fpWidth*windowWidth/0.8;
      // let height = fpHeight*windowHeight/0.8;
      // const dimObj = getFrameDim (height, width, window.innerHeight, window.innerWidth);
      // let fpx = ((window.innerWidth - 0.8*dimObj.width)/2)/window.innerWidth;
      // let fpy = ((window.innerHeight - 0.8*dimObj.height)/2)/window.innerHeight;
      // setFpWidth(0.8*dimObj.width/window.innerWidth);
      // setFpHeight(0.8*dimObj.height/window.innerHeight);
      // setFpx(fpx);
      // setFpy(fpy);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const updateUserObj = () => {
    setLoading(true)
    Network.getSubAndProjects(user.email, function (err, result) {
      if (err) {
        console.log(err);
        console.log("user obj did not get updated");
        setLoading(false);
      } else {
        // update user object
        console.log("update user obj endpoint returned");
        console.log(result);
        if (result.proj) {
          if ((!(result.proj.server_project_id in user.projects)) && user.sub_plan !== result.sub_plan) {
            console.log("updateing project and sub plan");
            setUser({...user, sub_plan: result.sub_plan, sub_cancel_pending: "", projects: 
              {...user.projects, [result.proj.server_project_id]: result.proj}});
          } else if (!(result.proj.server_project_id in user.projects)){
            setUser({...user, projects: 
              {...user.projects, [result.proj.server_project_id]: result.proj}});
          } else if (user.sub_plan !== result.sub_plan) {
            setUser({...user, sub_plan: result.sub_plan, sub_cancel_pending: ""});
          } else {
            console.log(`no update occurred`);
          }
        } else if (user.sub_plan !== result.sub_plan) {
          setUser({...user, sub_plan: result.sub_plan, sub_cancel_pending: ""});
        } else {
          console.log(`no update occurred`);
        }
        setLoading(false);
      }
    })
  }

  const changeProject = (projId) => {
    // get project snapshots before setting current project
    console.log("changing projects. proj Id:");
    console.log(projId);
    console.log(user.projects[projId]);
    setCurProj(projId);
    // fetch(`${prod_host}/floorplan-snapshots-stickynotes/${projId}`, {
    //   method: 'get',
    //   headers: {
    //    Accept: 'application/json',
    //   'Content-Type': 'application/json',
    //   'authorization': `Bearer ${user.accessToken}`
    //   }
    // })
    // .then(response => response.json())
    // .then(floorplans => {
    //   console.log(`Debug Log: Return from getSnapshots endpoint ${floorplans}`);
    //   console.log(floorplans);
    //   let fpId = Object.keys(floorplans)[0];
    //   let curSnapshots = floorplans[fpId].snapshots;
    //   console.log(`cur snapshots:`);
    //   console.log(curSnapshots)
    //   setUser({...user, projects: 
    //     {...user.projects, [projId]: 
    //     {...user.projects[projId].floorplans, [fpId]:
    //     {...user.projects[projId].floorplans[fpId], snapshots: curSnapshots}}}})
    //   setCurProj(projId);
    // })
    // .catch((error) => {
    //   console.log(`Exception occurred while getting snapshots`);
    //   console.log(error);
    // })
  }

  const onDoubleClick = (ssId) => {
    setSSDoubleClicked(ssId);
  }

  const leftOrRight = (ssId) => {
    const ssObjs = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].snapshots;
    const ogFpHeight = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height;
    const ogFpWidth = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width;
    const dimObj = getFrameDim (ogFpHeight, ogFpWidth, window.innerHeight, window.innerWidth);
    let fpX = ((windowWidth - 0.8*ssObjs[ssId].width)/2)/windowWidth;
    let fpY = ((windowHeight - 0.8*ssObjs[ssId].height)/2)/windowHeight;
    const fpWidth = (0.8*dimObj.width/windowWidth);
    const fpHeight = (0.8*dimObj.height/windowHeight);
    if (((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + ssObjs[ssId].renderWidth*windowWidth*0.4)
    > (fpX*windowWidth+(fpWidth*windowWidth))) {
      return -1*ssObjs[ssId].renderWidth*windowWidth*0.4+(fpWidth*windowWidth*snapSize); // magic number 0.4? - hard type this
    } else {
      return 0;
    }
  }

  const topOrBottom = (ssId) => {
    const ssObjs = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].snapshots;
    const ogFpHeight = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height;
    const ogFpWidth = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width;
    const dimObj = getFrameDim (ogFpHeight, ogFpWidth, window.innerHeight, window.innerWidth);
    let fpX = ((windowWidth - 0.8*ssObjs[ssId].width)/2)/windowWidth;
    let fpY = ((windowHeight - 0.8*ssObjs[ssId].height)/2)/windowHeight;
    const fpWidth = (0.8*dimObj.width/windowWidth);
    const fpHeight = (0.8*dimObj.height/windowHeight);
    if (((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + ssObjs[ssId].renderHeight*windowHeight*0.4)
    > (fpY*windowHeight+(fpHeight*windowHeight))) {
      return -1*ssObjs[ssId].renderHeight*windowHeight*0.4+(fpWidth*windowWidth*snapSize);
    } else {
      return 0;
    }
  }

  const getSnapshotStyle = (ssId) => {
    const ssObjs = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].snapshots;
    const ogFpHeight = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height;
    const ogFpWidth = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width;
    const dimObj = getFrameDim (ogFpHeight, ogFpWidth, window.innerHeight, window.innerWidth);
    let fpX = ((windowWidth - 0.8*ssObjs[ssId].width)/2)/windowWidth;
    let fpY = ((windowHeight - 0.8*ssObjs[ssId].height)/2)/windowHeight;
    const fpWidth = (0.8*dimObj.width/windowWidth);
    const fpHeight = (0.8*dimObj.height/windowHeight);
    if (ssObjs[ssId].coordinatex !== 0 || ssObjs[ssId].coordinatey !== 0) {
      console.log(`left: ${(fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth)}`);
      console.log(`top: ${(fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight)}`);
      // return {position: 'absolute', 
      // left: ssId!==ssDoubleClicked?(fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth)
      // :((fpX*windowWidth) + (ssObjs[ssId].coordinatex*fpWidth*windowWidth) + leftOrRight(ssId)), 
      // top: ssId!==ssDoubleClicked?(fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight)
      // :((fpY*windowHeight) + (ssObjs[ssId].coordinatey*fpHeight*windowHeight) + topOrBottom(ssId))
      // };
    } 
    // else if (ssId === ssDoubleClicked) {
    //   console.log("double clicked");
    //   const ssWidth = ssObjs[ssId].renderWidth*windowWidth*0.4;
    //   return {position: 'absolute', top: "50vh", left: "3.3vw"};
    // } else {
    //   return {};
    // }
  }

  const getSSWidth = (ssId) => {
    let ssWidth;
    const ssObjs = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].snapshots;
    const ogFpHeight = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height;
    const ogFpWidth = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width;
    const dimObj = getFrameDim (ogFpHeight, ogFpWidth, window.innerHeight, window.innerWidth);
    let fpX = ((windowWidth - 0.8*ssObjs[ssId].width)/2)/windowWidth;
    let fpY = ((windowHeight - 0.8*ssObjs[ssId].height)/2)/windowHeight;
    const fpWidth = (0.8*dimObj.width/windowWidth);
    const fpHeight = (0.8*dimObj.height/windowHeight);
    if (ssId === ssDoubleClicked) {
      ssWidth = ssObjs[ssId].renderWidth*windowWidth*0.4;
    } else {
      ssWidth = fpWidth*windowWidth*snapSize;
    }
    return ssWidth;
  }

  const getSSHeight = (ssId) => {
    let ssHeight;
    const ssObjs = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].snapshots;
    const ogFpHeight = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height;
    const ogFpWidth = user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width;
    const dimObj = getFrameDim (ogFpHeight, ogFpWidth, window.innerHeight, window.innerWidth);
    let fpX = ((windowWidth - 0.8*ssObjs[ssId].width)/2)/windowWidth;
    let fpY = ((windowHeight - 0.8*ssObjs[ssId].height)/2)/windowHeight;
    const fpWidth = (0.8*dimObj.width/windowWidth);
    const fpHeight = (0.8*dimObj.height/windowHeight);
    if (ssId === ssDoubleClicked) {
      ssHeight = ssObjs[ssId].renderHeight*windowHeight*0.4;
    } else {
      ssHeight = fpWidth*windowWidth*snapSize; // using width here is correct to make square icons
    }
    return ssHeight;
  }

  const onCreate = () => {
    navigate("/create");
  }

  const getProjTrxIds = (projId,btnType) => {
    console.log("in getProjTrxIds function");
    if (projTrxMap[projId]) {
      let url = "";
      if(btnType === "view") {
        url = `https://server.mapit.cc/share/${projTrxMap[projId].trxId}`;
      } else if (btnType === "edit") {
        url = `https://server.mapit.cc/edit/${projTrxMap[projId].editId}`;
      } else {
        url = `https://server.mapit.cc/qrcode/${projTrxMap[projId].trxId}`;
      }
      var win = window.open(url, '_blank');
      win.focus();
    } else {
      console.log("projId:")
      console.log(projId);
      setLoading(true);
      Network.getTrxAndEditIds(projId, function (err, trxIds) {
        if (err) {
          console.log(`Error return from getTrxAndEditIds request`);
          console.log(err);
          setLoading(false);
        } else {
          console.log(`trxIds returned from server`);
          console.log(trxIds);
          setProjTrxMap({...projTrxMap, [projId]: {trxId: trxIds.trx_id, editId: trxIds.edit_id}});
          let url = "";
          if (btnType === "view") {
            url = `https://server.mapit.cc/share/${trxIds.trx_id}`;
          } else if (btnType === "edit") {
            url = `https://server.mapit.cc/edit/${trxIds.edit_id}`;
          } else {
            url = `https://server.mapit.cc/qrcode/${trxIds.trx_id}`;
          }
          var win = window.open(url, '_blank');
          win.focus();
          setLoading(false);
        }
      })
    }
  }

  return (
  <>
    <PageTitle title="Project Floor Plans"/>
    {!isMobile
    ?
    <>
    {curProj != -1
    ?
    <div className='projectView'>
      <div className='projectList'>
      {reverseProjectKeys.map((projId, index) => (
        <>
          {reverseProjectKeys[0] === projId
          ?
          <div className="projects-first" onClick={() => changeProject(projId)} key={index}>
            <div className="project-text-div">
            {/* <p className="project-name-p">{user.projects[projId].name}</p> */}
              <p className="project-address-p">{user.projects[projId].address}</p>
            </div>
            <div className="project-btns">
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "view")} text="View" className="view-mapitBtn"></MapItButton>
              </div>
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "edit")} text="Edit" className="edit-mapitBtn"></MapItButton>
              </div>
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "qrcode")} text="QRC" className="edit-mapitBtn"></MapItButton>
              </div>
            </div>
          </div>
          :
          <div className="projects" onClick={() => changeProject(projId)} key={index}>
            <div className="project-text-div">
              {/* <p className="project-name-p">{user.projects[projId].name}</p> */}
              <p className="project-address-p">{user.projects[projId].address}</p>
            </div>
            <div className="project-btns">
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "view")} text="View" className="view-mapitBtn"></MapItButton>
              </div>
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "edit")} text="Edit" className="edit-mapitBtn"></MapItButton>
              </div>
              <div>
                  <MapItButton onSubmit={()=>getProjTrxIds(projId, "qrcode")} text="QRC" className="edit-mapitBtn"></MapItButton>
              </div>
            </div>
          </div>
          }
        </>
      ))}
      </div>
      <div className='fpView'>
        {Object.keys(user.projects[curProj].floorplans) != 0
        ?
        <img
        src={`https://d1se9yqadop5at.cloudfront.net/${user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].remote_file_path}`}
        width={getFrameDim(user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height, 
          user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width,
          window.innerHeight*0.77, window.innerWidth*0.58).width}
        height={getFrameDim(user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].height, 
          user.projects[curProj].floorplans[Object.keys(user.projects[curProj].floorplans)[0]].width,
          window.innerHeight*0.77, window.innerWidth*0.58).height}
        alt="Floor plan image. Refresh to render."/>
        :
        <div></div>
        }
        { loading &&
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
        }
      </div>
    </div>
    :
    <div className="project-view-no-proj">
      <div className="no-proj-msg">
        <p>No projects currently available.</p>
      </div>
      <div className="proj-view-create-button">
        <MapItButton onSubmit={()=>onCreate()} text="Create" className="createBtn-proj-view"></MapItButton>
      </div>
      { loading &&
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1,marginLeft: "48vw", marginTop: "40vh"}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
            }
    </div>
  }
    </>
    :
    <>
    {curProj != -1
    ?
    <div className='mprojectView'>
      <div className='mprojectList'>
      {reverseProjectKeys.map((projId, index) => (
      <>
      {reverseProjectKeys[0] === projId
      ?
      <div className="mprojects-first" onClick={() => changeProject(projId)} key={index}>
        <div className="project-text-div">
        {/* <p className="project-name-p">{user.projects[projId].name}</p> */}
          <p className="project-address-p">{user.projects[projId].address}</p>
        </div>
        <div className="project-btns">
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "view")} text="View" className="mview-mapitBtn"></MapItButton>
          </div>
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "edit")} text="Edit" className="medit-mapitBtn"></MapItButton>
          </div>
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "qrcode")} text="QRC" className="medit-mapitBtn"></MapItButton>
          </div>
        </div>
      </div>
      :
      <div className="mprojects" onClick={() => changeProject(projId)} key={index}>
        <div className="project-text-div">
          {/* <p className="project-name-p">{user.projects[projId].name}</p> */}
          <p className="project-address-p">{user.projects[projId].address}</p>
        </div>
        <div className="project-btns">
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "view")} text="View" className="mview-mapitBtn"></MapItButton>
          </div>
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "edit")} text="Edit" className="medit-mapitBtn"></MapItButton>
          </div>
          <div>
              <MapItButton onSubmit={()=>getProjTrxIds(projId, "qrcode")} text="QRC" className="medit-mapitBtn"></MapItButton>
          </div>
        </div>
      </div>
      }
    </>
  ))}
  </div>
</div>
:
  <div className="mproject-view-no-proj">
    <div className="mno-proj-msg">
      <p className="no-proj-p">No projects currently available.</p>
      <p className="use-desktop-p">Use our desktop version to create interactive floor plans.</p>
    </div>
    { loading &&
      <Loader.DotLoader
      color="#FCC81A"
      loading={loading}
      cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1,marginLeft: "48vw", marginTop: "40vh"}}
      size={48}
      aria-label="Loading Spinner"
      data-testid="loader"
      />
    }
  </div>
}
</>
    }
  </>
  );
}

export default ProjectView;